
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, IDocument } from "@tylertech/tyler-api-types";

/**
 * PayableImportService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PayableImportService<TImportPacket = unknown, TImportCriteria = unknown, TPacketCriteria = unknown> {
    private readonly $apiService = inject(ApiService);
    
    CreatePayment(packet: TPacketCriteria): Promise<void> {
        return this.$apiService.sendAuth("IPayableImportService/CreatePayment", packet);
    }
    DeleteImportPacket(packetId: string): Promise<void> {
        return this.$apiService.sendAuth("IPayableImportService/DeleteImportPacket", packetId);
    }
    DeletePurchaseCard(packetID: number): Promise<void> {
        return this.$apiService.sendAuth("IPayableImportService/DeletePurchaseCard", packetID);
    }
    GetDefaultImportCriteria(): Promise<TImportCriteria> {
        return this.$apiService.sendAuth("IPayableImportService/GetDefaultImportCriteria");
    }
    GetPCardImports(filterString?: string): Promise<TImportPacket[]> {
        return this.$apiService.sendAuth("IPayableImportService/GetPCardImports", null, filterString);
    }
    GetPurchaseCard(packetID: number): Promise<ExecutionResult<TPacketCriteria>> {
        return this.$apiService.sendAuth("IPayableImportService/GetPurchaseCard", packetID);
    }
    ImportWithDetails(pCriteria: TImportCriteria): Promise<ExecutionResult<TPacketCriteria>> {
        return this.$apiService.sendAuth("IPayableImportService/ImportWithDetails", pCriteria);
    }
    PayableImport(pCriteria: TImportCriteria): Promise<TImportPacket> {
        return this.$apiService.sendAuth("IPayableImportService/PayableImport", pCriteria);
    }
    RunReport(packetId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPayableImportService/RunReport", packetId);
    }
    SaveImportPacket(packet: TImportPacket): Promise<TImportPacket> {
        return this.$apiService.sendAuth("IPayableImportService/SaveImportPacket", packet);
    }
    SaveImportWithCriteria(pCriteria: TPacketCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IPayableImportService/SaveImportWithCriteria", pCriteria);
    }
    SubmitImport(packet: TPacketCriteria): Promise<ExecutionResult<TPacketCriteria>> {
        return this.$apiService.sendAuth("IPayableImportService/SubmitImport", packet);
    }
    UpdateStatus(packet: TPacketCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IPayableImportService/UpdateStatus", packet);
    }
}
